<template>
  <layout-default :hide-footer-mobile="true">
    <div
      class="step-3-content"
      data-aos="fade-left"
      data-aos-duration="1500"
      data-aos-once="true"
    >
      <div class="pdv-container">
        <div class="custom-padding">
          <div class="row">
            <div class="col">
              <button @click="$router.push('/packpdv')" type="button" class="btn-back-packs">
                <span class="btn-back-packs__arrow">←</span>
                Volver a ver Packs
              </button>
              <h3 class="section-title">Revisa y confirma tus cursos</h3>
            </div>
          </div>
          <div class="row" id="affixContainer">
            <div class="col-md-6 col-xs-12">
              <div class="checkout-card check-in-info-card">
                <div class="main-info">
                  <div
                    v-for="(student, index) in students"
                    :key="'student-' + index"
                  >
                    <div class="item">
                      <span class="item-head">Nombre del estudiante</span> <br />
                      <strong class="item-value">
                        {{ student.name + " " + student.fatherLastName + " " + student.lastName }}
                      </strong>
                    </div>
                    <div class="item">
                      <span class="item-head">Sede</span> <br />
                      <strong class="item-value">
                        {{ student.selectedLocation?.name || "-" }} *
                      </strong>
                    </div>
                  </div>
                  <div
                    v-for="(pack, packIdx) in cartPacks"
                    :key="'pack-' + packIdx"
                    :class="['pack-block', { 'pack-block--last': packIdx === cartPacks.length - 1 }]"
                  >
                    <div class="item">
                      <span class="item-head">Programa</span> <br />
                      <strong class="item-value">{{ pack.title }}</strong>
                    </div>
                    <div class="heading-info">
                      <span>Cursos</span> <br />
                      <div
                        class="item"
                        v-for="(detail, detailIdx) in (pack.PackDetails || [])"
                        :key="'d-' + packIdx + '-' + detailIdx"
                      >
                        <strong>{{ detail.Course?.Subject?.name || detail.Course?.name }}</strong>
                        <p>
                          <template v-for="schedule in (detail.Course?.Schedules || [])">
                            {{ schedule.dayOfWeek.substr(0, 3) }}
                            {{ schedule.startTime.replaceAll(":00", "") }} a
                            {{ schedule.endTime.replaceAll(":00", "") }} hs
                          </template>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="cartPacks.length > 0"
                    class="price-info price-info--inline"
                  >
                    <!-- Subtotal (con tachado si hay descuento) -->
                    <div v-if="discount > 0" class="monto-total">
                      <span class="key">Subtotal</span>
                      <strong :class="{ 'price-strikethrough': discount > 0 }">
                        {{ subTotal | moneyFormatter }}
                      </strong>
                    </div>

                    <!-- % descuento por sesiones (solo si existe) -->
                    <div v-if="discount > 0" class="monto-total monto-descuento">
                      <span class="key">% Descuento por sesiones</span>
                      <strong class="descuento-value">{{ discount }}%</strong>
                    </div>

                    <!-- Monto pack final -->
                    <div class="monto-total monto-final">
                      <span class="key key--bold">Monto pack</span>
                      <strong class="key--bold">* {{ total | moneyFormatter }}</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div class="note w-full d-flex">
                <div>
                  <img src="/images/featured/warning.svg" alt="warning" />
                </div>
                <div class="flex-1">
                  <div class="title-note">IMPORTANTE</div>
                  <p class="text-note">
                    * El monto obtenido en tu cotización corresponde al
                    <b>valor anual</b> de tu programa
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 position-relative d-md-block">
              <affix relative-element-selector="#affixContainer" class="">
                <div>
                  <abstract-check-in-info-outlet
                    @buttonClicked="saveOrderData"
                    @apllyCouponClicked="appllyCoupon"
                    @addCouponClicked="addCoupon"
                    @removeCoupon="removeCoupon"
                    :total="total"
                    :subTotal="subTotal"
                    :validCoupon="validCoupon"
                    :valorDescuentoCupon="valueCoupon"
                    :valorDescuento="0"
                    :precioSubTotal="subTotal"
                    :discountPercent="discount || 0"
                  ></abstract-check-in-info-outlet>
                </div>
              </affix>
              <div class="only-mobileBlock margen-custom-total">
                <div>
                  <abstract-check-in-info-outlet
                    @buttonClicked="saveOrderData"
                    @apllyCouponClicked="appllyCoupon"
                    @addCouponClicked="addCoupon"
                    @removeCoupon="removeCoupon"
                    :total="total"
                    :subTotal="subTotal"
                    :validCoupon="validCoupon"
                    :valorDescuentoCupon="valueCoupon"
                    :valorDescuento="0"
                    :precioSubTotal="subTotal"
                    :discountPercent="discount || 0"
                  ></abstract-check-in-info-outlet>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--unknow-error-modal /-->
      <form
        id="webpayFormOulet"
        :action="webpay ? webpay.url : ''"
        method="post"
        class="hidden-form"
      >
        <input
          type="hidden"
          name="token_ws"
          :value="webpay ? webpay.token : ''"
        />
        <button type="submit">Enviar</button>
      </form>

      <div v-if="showModal" class="modal-intensive modal-intensive--compact" id="modalIntensive">
        <div class="content content--compact realtive">
          <div class="text-content text-content--compact">
            <h4 class="title-modal">
              Espera un momento mientras <br />
              procesamos tu solicitud
            </h4>
            <p class="title-modal title-modal--sub">Esto puede demorar unos segundos.</p>
          </div>
        </div>
      </div>

      <div id="formsList" class="container position-relative">
        <div class="d-none alert-info">
          <div>
            <img src="/images/iconos/clock-white.svg" alt="" />
            <p>Tus cupos estarán asegurados por</p>
            <span>{{ quotasTimeRemaining | timeRemaining }}</span>
          </div>
        </div>

        <a
          style="visibility: hidden"
          ref="btnCancelPay"
          data-backdrop="static"
          data-keyboard="false"
          href=".cancel-pay-modal"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnSuccessfulFlowModal"
          data-backdrop="static"
          data-keyboard="false"
          href=".successful-flow-modal"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnSuccessModalWithCoupon"
          data-backdrop="static"
          data-keyboard="false"
          href=".success-modal-with-coupon"
          data-toggle="modal"
        ></a>
        <a
          style="visibility: hidden"
          ref="btnUnknowErrorModal"
          data-backdrop="static"
          data-keyboard="false"
          href=".unknow-error-modal"
          data-toggle="modal"
        ></a>
      </div>

      <error-pay-modal @onPay="tryToPayAgain" />
      <successful-flow-modal @onContinue="redirectToWebpay" />
    </div>
  </layout-default>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import LayoutDefault from "@/layouts/Default";
import StepsHeaderOutlet from "@/components/StepsHeaderOutlet";
import AbstractCheckInInfoOutlet from "@/components/AbstractCheckInInfoOutlet";
import ErrorPayModal from "@/components/modals/ErrorPayModal";
import SuccessfulFlowModal from "@/components/modals/SuccessfulFlowModal";
import outletCartService from "@/services/outletCartService";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

export default {
  data() {
    return {
      webpay: null,
      showModal: false,
      interval: null,
      total: null,
      discount: null,
      coupon: null,
      valueCoupon: 0,
      subTotal: 0,
      validCoupon: true,
    };
  },

  components: {
    LayoutDefault,
    StepsHeaderOutlet,
    AbstractCheckInInfoOutlet,
    ErrorPayModal,
    SuccessfulFlowModal,
  },
  computed: {
    ...mapState(["students", "quotasTimeRemaining"]),
    programSelectedTitle() {
      return "PSU " + this.$store.state.student.program;
    },
    selectedProgram() {
      return this.$store.state.selectedProgram;
    },
    selectedSubjects() {
      return this.$store.state.selectedSubjects;
    },
    selectedSubjectsWithCourses() {
      return this.$store.state.selectedSubjectsWithCourses;
    },
    selectedPack() {
      try {
        const raw = localStorage.getItem("pack");
        return raw ? JSON.parse(raw) : null;
      } catch {
        return null;
      }
    },
    cartPacks() {
      const cart = outletCartService.getCart();
      if (cart && cart.length > 0) return cart;
      const single = this.selectedPack;
      return single ? [single] : [];
    },
    totalPackAmount() {
      return (this.cartPacks || []).reduce(
        (sum, pack) => sum + (Number(pack.priceOfert) || 0),
        0
      );
    },
    students() {
      return this.$store.state.students;
    },
    selectedCourses() {
      return this.$store.state.selectedCourses;
    },
  },
  methods: {
    ...mapActions([
      "setQuotasTimeRemaining",
      "clearCoursesNotAvailables",
      "setCoursesNotAvailables",
    ]),
    clearAllCachedData() {
      try {
        localStorage.removeItem('outletStep1Data');
        localStorage.removeItem('outletStep2Data');
        localStorage.removeItem('pack');
        localStorage.removeItem('fullOrder');
      } catch (error) {
        console.error('Error clearing cached data:', error);
      }
    },
    round(num, decimalPlaces = 2) {
      let newNum = num * 100;
      return Math.round(newNum);
    },
    tryToPayAgain() {
      this.accept = true;
      setTimeout(() => {
        this.$refs.payButton.click();
      }, 500);
    },
    discountSeconds() {
      const currentTime = moment(this.quotasTimeRemaining, "mm:ss").subtract(
        1,
        "second"
      );
      this.setQuotasTimeRemaining(currentTime.format("mm:ss"));
    },
    getPercentaje() {
      if (this.subTotal === 0) {
        return 0;
      } else {
        return Math.round(((this.subTotal - this.total) * 100) / this.subTotal);
      }
    },
    getSchedule(hoursPerDay) {
      let days = "";
      if (hoursPerDay.length == 1) {
        days =
          hoursPerDay[0].day +
          " " +
          hoursPerDay[0].startTime.slice(0, -3) +
          " a " +
          hoursPerDay[0].endTime.slice(0, -3);
      } else if (hoursPerDay.length == 2) {
        if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else {
          days =
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3);
        }
      } else if (hoursPerDay.length == 3) {
        if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[2].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3);
        } else if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[2].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[2].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[1].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3);
        } else if (
          hoursPerDay[2].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[2].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[2].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[2].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[2].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[2].endTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            ", " +
            hoursPerDay[1].day +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else {
          days =
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            ", " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3);
        }
      }
      return days;
    },
    async saveOrderData() {
      this.showModal = true;
      const packs = this.cartPacks;
      const fullOrderStudentsData = [];
      packs.forEach((pack) => {
        const locationId = pack.Location?.id || this.students[0]?.selectedLocation?.id;
        const programId = pack.PackDetails?.[0]?.Course?.Program?.id || this.students[0]?.program?.id;
        const coursesIds = (pack.PackDetails || [])
          .map((d) => d.Course?.id)
          .filter(Boolean);
        if (locationId && programId && coursesIds.length > 0) {
          this.students.forEach((student) => {
            if (student.id) {
              fullOrderStudentsData.push({
                locationId,
                programId,
                coursesIds,
                studentId: student.id,
              });
            }
          });
        }
      });

      this.students[0] = {
        ...this.students[0],
        packId: packs[0]?.id || this.selectedPack?.id,
      };

      const sessionState = { students: this.students };
      // Usar el total descontado en lugar del monto sin descuento
      const amountPack = this.total;

      const newFullOrder = {
        ...this.$store.state.fullOrder,
        financingParty: this.$store.state.fullOrder.financingParty || this.$store.state.financingParty,
        orderDetails: fullOrderStudentsData,
        coupon: this.coupon,
        rut: this.rut,
        sessionState: JSON.stringify(sessionState),
        isOulet: true,
        amountPack,
      };

      localStorage.removeItem("fullOrder");
      localStorage.setItem("fullOrder", newFullOrder);
      this.startTransaction(newFullOrder);
    },
    async startTransaction(newFullOrder) {
      //this.showModal = true;

      try {
        const { data: order } = await this.Axios.put("/orders", newFullOrder, {
          withCredentials: true,
        });

        this.webpay = {
          url: order.url,
          token: order.token,
        };

        //validar que si es = muestre otro modal

        let promises = this.students.map((student) => {
          return this.Axios.put(`/students/${student.id}`, {
            financingPartyId: order.financingPartyId,
            caretakerId: order.caretakerId,
          });
        });
        await Promise.all(promises);

        if (order.url == null && order.token == null) {
          this.showModal = false;
          this.$refs.btnSuccessModalWithCoupon.click();
        } else {
          this.showModal = false;
          this.$refs.btnSuccessfulFlowModal.click();
        }
      } catch (err) {
        this.showModal = false;

        if (err.response?.data?.name === "CourseNotAvailable") {
          this.setCoursesNotAvailables(err.response.data.coursesNotAvailables);
        } else if (err.response?.data?.name === "UnknowError") {
          this.$refs.btnUnknowErrorModal.click();
        } else {
          // Error genérico - mostrar alerta
          this.$swal.fire({
            icon: 'error',
            title: 'Error al procesar solicitud',
            text: 'No podemos generar tu solicitud en este momento. Por favor, intenta más tarde.',
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#000000'
          });
        }
      }
    },
    async appllyCoupon() {
      // Coupon validation removed - no longer using quote API
    },
    addCoupon() {
      this.validCoupon = true;
    },
    setTotal() {
      const packs = this.cartPacks;
      this.total = packs.reduce((s, p) => s + (parseInt(p?.priceOfert, 10) || 0), 0) || 0;
    },

    goToNextStep() {
      this.$router.push({ name: "Step4" });
    },
    addOtherStudent() {
      this.$store.dispatch("showBackpack").then(() => {
        this.$router.push({ name: "BuyOtherProgram" });
      });
    },
    removeCoupon() {
      this.coupon = null;
      this.valueCoupon = 0;
      this.validCoupon = true;
    },
    redirectToWebpay() {
      outletCartService.clear();
      this.clearAllCachedData();
      document.getElementById("webpayFormOulet").submit();
    },
  },

  async mounted() {
    const packs = this.cartPacks;
    const packTotal = packs.length
      ? packs.reduce((s, p) => s + (parseInt(p.priceOfert, 10) || 0), 0)
      : 0;
    this.subTotal = packTotal;
    this.total = packTotal;

    // El descuento adicional por sesiones solo aplica cuando hay 2+ packs
    if (packs.length > 1) {
      const sessionCount = packs.reduce((sum, pack) => {
        const details = Array.isArray(pack.PackDetails) ? pack.PackDetails : [];
        return sum + details.reduce((s, d) => s + (parseInt(d.sessions, 10) || 0), 0);
      }, 0);
      if (sessionCount > 0) {
        try {
          const { data } = await this.Axios.get('/dashadmin/packs/discount-by-sessions', {
            params: { quantity: sessionCount }
          });
          const sessionDiscount = Number(data?.discount) || 0;
          this.discount = sessionDiscount;
          if (sessionDiscount > 0) {
            this.total = Math.round(packTotal * (1 - sessionDiscount / 100));
          }
        } catch (e) {
          console.error('Error fetching session discount:', e);
        }
      }
    }

    await this.$store.dispatch("clearSelectedSubjects");
    (this.selectedSubjectsWithCourses || []).forEach((subject) => {
      if (!subject) return;
      let newSubject = {
        createdAt: subject.createdAt,
        hasMention: subject.hasMention,
        id: subject.id,
        name: subject.name,
        pdvId: subject.pdvId,
        updatedAt: subject.updatedAt,
        courses: [],
        subject: {
          createdAt: subject.createdAt,
          hasMention: subject.hasMention,
          id: subject.id,
          name: subject.name,
          pdvId: subject.pdvId,
          updatedAt: subject.updatedAt,
        },
      };
      this.$store.dispatch("addSubject", newSubject);
    });

    // Reconstruir cursos directamente desde el carrito (que tiene Schedules completos desde Step1)
    const arrayCourses = [];
    this.cartPacks.forEach((pack) => {
      (pack.PackDetails || []).forEach((detail) => {
        const course = detail.Course;
        if (!course) return;
        const schedules = course.Schedules || [];
        const subjectName = course.Subject?.name || course.subjectName;
        if (!subjectName) return;
        arrayCourses.push({
          courseId: course.id || course.courseId,
          hour: schedules.map(s => `${s.dayOfWeek} ${s.startTime?.slice(0, 5)}-${s.endTime?.slice(0, 5)}`).join(', '),
          lastSeats: false,
          days: [...new Set(schedules.map(s => s.dayOfWeek))],
          subjectName,
          coursePdvId: course.pdvId || course.coursePdvId,
          coursePdvCode: course.pdvCode || course.coursePdvCode,
          subjectId: course.subjectId || course.SubjectId || course.Subject?.id,
          blocks: schedules.map(s => s.block).filter(b => b != null),
          schedulesPerDayOfThisCourse: schedules.map(s => `${s.dayOfWeek} ${s.startTime?.slice(0, -3)} a ${s.endTime?.slice(0, -3)}`),
          coursesWithSameSchedule: [],
          hoursPerDay: schedules.map(s => ({
            day: s.dayOfWeek,
            startTime: s.startTime,
            endTime: s.endTime,
            subject: subjectName,
            block: s.block,
          })),
        });
      });
    });

    this.$store.dispatch("clearSelectedCourses");
    arrayCourses.forEach((course) => {
      this.$store.dispatch("saveCourseSelected", course);
    });

    /*this.$store.dispatch("clearSelectedSubjects").then(() => {
      newSubject.forEach(s => {
        this.$store.dispatch("addSubject", s);
      })
    })*/

    /*await this.$store.dispatch("clearCoursesNotAvailables");
    await this.$store.dispatch("addInfoToFullOrder", {
      // sessionState: JSON.stringify(sessionState)
      sessionState: JSON.stringify(copySesion)
    });*/
    await this.Axios.put(
      "/orders",
      {
        ...this.$store.state.fullOrder,
        financingParty: this.$store.state.fullOrder.financingParty || this.$store.state.financingParty,
        isOulet: true,
        sessionState: JSON.stringify({ students: this.students }),
        amountPack: this.total,
      },
      { withCredentials: true }
    );

    const zoomScript = document.createElement("script");
    zoomScript.src = "https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js";
    zoomScript.setAttribute("data-apikey", "G4nAX1GiTf6ib-GJAcV4Qw");
    zoomScript.setAttribute("data-env", "us01");
    zoomScript.async = true;
    document.body.appendChild(zoomScript);
  },

  beforeDestroy() {
    const script = document.querySelector('script[src="https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js"]');
    if (script) {
      script.remove();  // Elimina el script al salir de la página
    }
    //clearInterval(this.interval);
  },
  filters: {
    timeRemaining(time) {
      return moment(time, "mm:ss").format("mm’ ss’’");
    },
  },

};
</script>

<style scoped lang="scss">
.btn-back-packs {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 24px;
  margin-top: 32px;
  margin-bottom: 12px;
  border-radius: 50px;
  border: 2px solid #fff;
  background-color: #3691d8;
  color: #fff;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(54, 145, 216, 0.4);

  &:hover {
    background-color: #2a7bc7;
  }

  &__arrow {
    font-size: 1rem;
    line-height: 1;
  }
}

.margen-custom-total {
  @media (max-width: 768px) {
    margin-top: 40px;
    margin-right: -24px !important;
    margin-left: -24px !important;
  }
}

.boton-new-primario {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $morado50;
  border: solid 4px $neutralwhite;
  color: $neutralwhite;
  &:hover {
    background-color: $morado30;
  }
  &:active {
    background-color: $morado90;
  }
  &:focus {
    background-color: $morado50;
    border: solid 4px grey;
  }
  &:disabled {
    background-color: #5924661a;
  }

  &.boton-new-largo {
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  &.boton-new-mediano {
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 18px;
  }
  &.boton-new-pequeno {
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }

  img {
    margin-right: 16px;
  }
}

.pack-block {
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px dashed #e5e7eb;

  &--last {
    border-bottom: none;
    margin-bottom: 0;
  }
}

.price-info--inline {
  border-top: none;
  padding-top: 0;
  .monto-total {
    border-top: none;
    padding: 4px 0 !important;
  }
}

.price-strikethrough {
  text-decoration: line-through;
  color: #9ca3af;
}

.monto-descuento strong {
  color: #000;
}

.monto-final {
  border-top: 1px solid #e5e7eb;
  margin-top: 4px;
  padding-top: 8px !important;
}

.key--bold {
  font-family: 'Poppins-Bold', sans-serif;
  font-weight: 700;
}

.price-info {
  border-top: 2px dotted #cacbce;

  .header-total {
    padding: 20px 0px 10px 0px;
  }

  .descuento {
    color: green;
    padding: 8px 0px 10px 0px;
  }

  .monto-total {
  
    padding: 20px 0 20px 0;
    display: flex;
    justify-content: space-between;
  }
}


.imagen-pensar {
  @media (min-width: 769px) {
    margin-top: -170px;
  }
}

.w-accordion-custom {
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (min-width: 769px) {
    width: 352px;
  }
}

.custom-padding {
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}

.step-3-content {
  @media (min-width: 769px) {
    padding-bottom: 48px;
  }

  .section-title {
    color: $neutralBlack;
    font-family: "Poppins-Bold", sans-serif;
    padding-top: 0;
    margin-top: 0;
    font-style: normal;
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 28px;
    }
    @media (min-width: 769px) {
      font-size: 32px;
      line-height: 42px;
    }
  }

  .vue-affix {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  h3 {
    font-size: 18px;
    line-height: 26px;
    @include alternative-regular;
    margin-bottom: 15px;
    @include media-breakpoint-down(sm) {
      margin-top: 20px;
    }
  }
}
.img-modal-loading {
  position: absolute;
  right: 8px;
  bottom: 20px;
  height: 80%;

  @media (max-width: 768px) {
    display: none;
  }
}
.title-modal {
  text-align: center;
  margin: 10px;
}

/* Base del modal de carga (outlet Step3) */
.modal-intensive {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(134, 133, 133, 0.1);
}
.modal-intensive .content {
  position: relative;
  width: 40%;
  min-width: 280px;
  border-radius: 24px;
  border: 2px solid #000;
  background: #fff;
  padding: 24px;
  box-shadow: 0 0 12px 3px rgba(0, 0, 0, 0.22);
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 768px) {
    width: 90%;
  }
}
.modal-intensive .text-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* Modal más compacto (menor alto y ancho) */
.modal-intensive--compact .content--compact {
  width: 32%;
  max-width: 340px;
  min-height: 180px;
  padding: 20px 24px;
  @media (max-width: 768px) {
    width: 85%;
    max-width: none;
  }
}
.modal-intensive--compact .text-content--compact {
  padding: 0 16px;
}
.modal-intensive--compact .title-modal {
  margin: 4px 0;
  font-size: 1.1rem;
  line-height: 1.4;
}
.modal-intensive--compact .title-modal--sub {
  margin: 0;
  font-size: 0.9rem;
}

div .underline-link {
  margin-left: 105px;
}

.alert-info {
  display: flex;
  align-items: center;
  background: $red-2;
  padding: 5px 25px;
  position: absolute;
  top: -45px;
  right: 15px;

  img {
    width: 25px;
    @include media-breakpoint-down(sm) {
      width: 22px;
    }
  }

  p {
    color: #fff;
    margin-bottom: 0;
    font-size: 14px;
    @include alternative-light-regular;
    margin: 0 5px;
  }

  span {
    color: #fff;
    font-size: 20px;
    @include alternative-medium-regular;
    @include media-breakpoint-down(sm) {
      font-size: 18px;
    }
  }

  @include media-breakpoint-down(sm) {
    width: calc(100% + 30px);
    position: static;
    right: unset;
    top: unset;
    margin-left: -15px;
    margin-right: -15px;
    justify-content: center;
    padding: 5px 4px;
  }
}

.checkout-card {
  border-radius: 8px;
  border: 1px solid $neutralBlack;
  padding: 16px;
  margin-bottom: 30px;
}

.check-in-info {
  .check-in-info-card {
    border-radius: 8px;
    border: 1px solid $neutralBlack;
    padding: 16px;
    margin-bottom: 30px;

    .number-student-tag {
      letter-spacing: 2px;
      font-size: 12px;
      line-height: 22px;
      margin-bottom: 22px;
      @include alternative-regular;
      color: $gray;
      display: inline-block;
    }

    ul {
      padding-left: 0;
      margin-bottom: 0;

      li {
        display: flex;
        justify-content: space-between;
        list-style: none;
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        span {
          font-size: 14px;
          @include alternative-light-regular;

          .index-number {
            font-size: 16px;
            @include alternative-medium-regular;
          }

          &:last-child {
            text-align: right;
          }
        }

        &.heading-info {
          span {
            color: $neutral70;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
          }
        }

        &.promo-info-item {
          span {
            @include media-breakpoint-down(sm) {
              font-size: 12px;
            }
            color: $green;
            font-size: 16px;
            line-height: 5px;
            @include alternative-medium-regular;
          }
        }
      }
    }

    .heading-info {
      span {
        color: $neutral70;
        font-family: "Poppins-Bold", sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: 22px;
      }
    }

    .main-info {
      padding-bottom: 30px;
      margin-bottom: 16px;
      border-bottom: 2px dashed #cacbce;

      .item {
        display: flex;
        flex-direction: column;
        margin-bottom: 12px;

        .item-head {
          color: #4e4f55;
          font-family: "Poppins-Regular", sans-serif;
          font-size: 14px;
          font-style: normal;
          line-height: 22px;
        }

        .item-value {
          color: $neutralBlack;
          font-family: "Poppins-Medium", sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px;

          span {
            color: $neutralBlack;
            font-family: "Poppins-Medium", sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
          }
        }
      }

      .info-item {
        margin-bottom: 10px;
      }
      .info-item > span:last-child {
        @include alternative-regular;
        color: #000;
      }
    }

    .coupon-info {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 0.5px solid $gray;

      .amounts {
        .amount-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .key {
            color: $succes80;
            font-family: "Poppins-Regular", sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
          }

          .value {
            color: $succes80;
            font-family: "Poppins-Medium", sans-serif;
            font-size: 12px;
            font-style: normal;
            line-height: 16px;
          }
        }
      }
    }

    .amount-discounts {
      padding-top: 1rem;
      border-top: 2px dashed #cacbce;
    }

    .final-price-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .key {
        color: $neutralBlack;
        font-family: "Poppins-Regular", sans-serif;
        @media (max-width: 768px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
        }
        @media (min-width: 769px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
        }
      }
      .value {
        color: $neutral70;
        font-family: "Poppins-Bold", sans-serif;
        text-align: right;
        @media (max-width: 768px) {
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 28px;
        }
        @media (min-width: 769px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
        }
      }
    }
  }
}

.note {
  border-radius: 8px;
  border: 1px solid #f1c469;
  background: #fffaf0;
  box-sizing: border-box;
  padding: 12px 16px;
  margin-top: 25px;
  img {
    margin-right: 12px;
  }
}

.note-mobile {
  display: none;
  border-radius: 8px;
  border: 1px solid #f1c469;
  background: #fffaf0;
  box-sizing: border-box;
  padding: 20px;
  @include alternative-regular;
  width: 100%;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
}

.title-note {
  color: #966a11;
  font-family: "Poppins-Medium", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.text-note {
  color: #966a11;
  font-family: "Poppins-Regular", sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 22px;

  span {
    font-family: "Poppins-Bold", sans-serif;
  }
}

.vue-affix {
  flex-direction: column !important;
  align-items: flex-end !important;
}

.hidden-form {
  position: absolute;
  visibility: hidden;
}
</style>
